<div class="fluid-container">
  <div class="row pt-4 d-flex align-items-center">
    <div class="col-md-11 step-title p-0">
      <h5 class="mb-0">Update Determination</h5>
    </div>
    <div class="col-md-1 pr-0 d-flex justify-content-end">
      <i (click)="handleClose();" class="close-icon pi pi-times"></i>
    </div>
  </div>
  <p-divider></p-divider>
</div>
<div class="dynamic-dialog-page-content">
  <form class="p-form" [formGroup]="updateDeterminationForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="row">
        <div class="form-group col-3">
          <label class="p-label required">PW Tracking Number</label>
          <p-inputMask mask="a-999-99999-999999" class="p-form-control" formControlName="pwtrackNumber"
            placeholder="Enter"></p-inputMask>
          <small
            *ngIf="!updateDeterminationForm.get('pwtrackNumber').valid && updateDeterminationForm.get('pwtrackNumber').touched && updateDeterminationForm.get('pwtrackNumber').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('pwtrackNumber').errors['required']">PW Tracking Number is
              required.</span></small>
        </div>
        <div class="form-group col-3">
          <label class="p-label required">Decision</label>
          <p-dropdown appendTo="body" placeholder="Select" class="p-form-control" [options]="decisionList"
            optionValue="code" (onChange)="onDecisionChange()" optionLabel="name"
            formControlName="decisionCode"></p-dropdown>
          <small
            *ngIf="!updateDeterminationForm.get('decisionCode').valid && updateDeterminationForm.get('decisionCode').touched && updateDeterminationForm.get('decisionCode').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('decisionCode').errors['required']">Decision is
              required.</span></small>
        </div>
        <div class="form-group col-3">
          <label class="p-label required">Date Filed</label>
          <p-calendar appendTo="body" styleClass="p-form-datepicker" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [showIcon]="true" formControlName="filingDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="{{fromYear}}:{{toYear}}">
          </p-calendar>
          <small
            *ngIf="!updateDeterminationForm.get('filingDate').valid && updateDeterminationForm.get('filingDate').touched && updateDeterminationForm.get('filingDate').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('filingDate').errors['required']">Date Filed is
              required.</span></small>
        </div>
        <div class="form-group col-3" *ngIf="updateDeterminationForm.get('decisionCode').value === 'PWDISSUED'">
          <label class="p-label required">Date of Determination</label>
          <p-calendar appendTo="body" styleClass="p-form-datepicker" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [showIcon]="true"
            [minDate]="updateDeterminationForm.get('filingDate').value"
            formControlName="determinationDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="{{fromYear}}:{{toYear}}">
          </p-calendar>
          <small
            *ngIf="!updateDeterminationForm.get('filingDate').valid && updateDeterminationForm.get('filingDate').touched && updateDeterminationForm.get('filingDate').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('filingDate').errors['required']">Date Filed is
              required.</span></small>
        </div>
      </div>
      <div class="row" *ngIf="updateDeterminationForm.get('decisionCode').value === 'PWDISSUED'">
        <div class="form-group col-3">
          <label class="p-label required">Validity From</label>
          <p-calendar appendTo="body" styleClass="p-form-datepicker" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [showIcon]="true" formControlName="validityFromDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="{{fromYear}}:{{toYear}}" (onSelect)="onValidityFromDate()">
          </p-calendar>
          <small
            *ngIf="!updateDeterminationForm.get('validityFromDate').valid && updateDeterminationForm.get('validityFromDate').touched && updateDeterminationForm.get('validityFromDate').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('validityFromDate').errors['required']">Validity From is
              required.</span></small>
        </div>
        <div class="form-group col-3">
          <label class="p-label required">Validity To</label>
          <p-calendar styleClass="p-form-datepicker" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [showIcon]="true"
            [minDate]="minValidityToDate"
            formControlName="validityToDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="{{fromYear}}:{{toYear}}">
          </p-calendar>
          <small
            *ngIf="!updateDeterminationForm.get('validityToDate').valid && updateDeterminationForm.get('validityToDate').touched && updateDeterminationForm.get('validityToDate').errors"
            class="p-error">
            <span *ngIf="updateDeterminationForm.get('validityToDate').errors['required']">Validity To is
              required.</span></small>
        </div>
        <div class="form-group col-3">
          <label class="p-label required">SOC Code</label>
          <p-inputMask mask="99-9999.99" class="p-form-control" formControlName="socCode" placeholder="Enter">
          </p-inputMask>
          <small
            *ngIf="!updateDeterminationForm.get('socCode').valid && updateDeterminationForm.get('socCode').errors && updateDeterminationForm.get('socCode').touched"
            class="p-error">
            <span class="d-block" *ngIf="updateDeterminationForm.get('socCode').errors['required']">SOC Code is
              required.</span>
            <span class="d-block" *ngIf="updateDeterminationForm.get('socCode').errors['SOCCodeInvalid']">SOC Code is
              invalid.</span>
          </small>
        </div>
        <div class="form-group col-3">
          <label class="p-label">SOC Occupation title</label>
          <input type="text" readonly pInputText class="p-form-control" placeholder="Enter"
            formControlName="socTitle" />
        </div>
      </div>
    </div>
    <p-divider></p-divider>
    <ng-template [ngIf]="updateDeterminationForm.get('decisionCode').value === 'PWDISSUED'">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h6 class="greencard-pwd-sub-header">Prevailing Wage Information</h6>
          </div>
        </div>
        <div formArrayName="determinationWageInfo">
          <div *ngFor="let formGroup of groups; let i = index;">
            <div [formGroupName]="i">
              <div class="row">
                <div class="form-group col-6">
                  <label class="p-label required">Location</label>
                  <label class="p-label p-label-bold d-block">{{ formGroup.get('locationAddrName').value }}</label>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-3">
                  <label class="p-label required">Prevailing Wage</label>
                  <p-inputNumber mode="currency" currency="USD" [min]="0" [max]="1000000000" [maxlength]="17"
                    locale="en-US" formControlName="prvlWageAmt" placeholder="Enter">
                  </p-inputNumber>
                  <small
                    *ngIf="!formGroup.get('prvlWageAmt').valid && formGroup.get('prvlWageAmt').touched && formGroup.get('prvlWageAmt').errors"
                    class="p-error">
                    <span *ngIf="formGroup.get('prvlWageAmt').errors['required']">Prevailing Wage is
                      required.</span></small>
                </div>
                <div class="form-group col-3">
                  <label class="p-label required">Wage Unit</label>
                  <p-dropdown placeholder="Select" class="p-form-control" [options]="wageUnitList" optionValue="code"
                    optionLabel="name" formControlName="prvlWageUnitCode"></p-dropdown>
                  <small
                    *ngIf="!formGroup.get('prvlWageUnitCode').valid && formGroup.get('prvlWageUnitCode').touched && formGroup.get('prvlWageUnitCode').errors"
                    class="p-error">
                    <span *ngIf="formGroup.get('prvlWageUnitCode').errors['required']">Wage Unit is
                      required.</span></small>
                </div>
                <div class="form-group col-3">
                  <label class="p-label required">OES Wage level</label>
                  <p-dropdown placeholder="Select" class="p-form-control" [options]="OESWageLevelList"
                    optionValue="code" optionLabel="name" formControlName="oesWageLevelCode"></p-dropdown>
                  <small
                    *ngIf="!formGroup.get('oesWageLevelCode').valid && formGroup.get('oesWageLevelCode').touched && formGroup.get('oesWageLevelCode').errors"
                    class="p-error">
                    <span *ngIf="formGroup.get('oesWageLevelCode').errors['required']">OES Wage level is
                      required.</span></small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-3">
                  <label class="p-label required">Prevailing wage source</label>
                  <p-dropdown placeholder="Select" class="p-form-control" [options]="prevailingWageSourceList"
                    optionValue="code" optionLabel="name" formControlName="prvlWageSourceCode"></p-dropdown>
                  <small
                    *ngIf="!formGroup.get('prvlWageSourceCode').valid && formGroup.get('prvlWageSourceCode').touched && formGroup.get('prvlWageSourceCode').errors"
                    class="p-error">
                    <span *ngIf="formGroup.get('prvlWageSourceCode').errors['required']">Prevailing wage source is
                      required.</span></small>
                </div>
                <div class="form-group col-6" *ngIf="formGroup.get('prvlWageSourceCode').value === 'OTHER'">
                  <label class="p-label required">Please specify the wage source</label>
                  <input type="text" pInputText class="p-form-control" placeholder="Enter"
                    formControlName="otherWageSource" />
                  <small
                    *ngIf="!formGroup.get('otherWageSource').valid && formGroup.get('otherWageSource').touched && formGroup.errors"
                    class="p-error">
                    <span *ngIf="formGroup.errors['otherWageSourceIsRequired']">Prevailing wage source is
                      required.</span></small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-9">
                  <label class="p-label">Additional notes regarding Wage Determination</label>
                  <input type="text" pInputText class="p-form-control" placeholder="Enter" formControlName="notes" />
                </div>
              </div>
              <div class="row" *ngIf="i < (groups.length - 1)">
                <div class="col-9">
                  <p-divider></p-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-9">
            <p-divider></p-divider>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <h6 class="greencard-pwd-sub-header">Upload Prevailing wage determination (ETA-9141)</h6>
          </div>
        </div>
        <div class="row pb-4">
          <div class="col-12 mb-3">
            <p-fileUpload *ngIf="!fileUploaded || (fileUploaded && fileUploaded.length === 0)" #fileUpload mode="basic"
              accept=".pdf" customUpload="true" (uploadHandler)="myUploader($event, fileUpload)" [auto]="true"
              class="gc-file-upload" chooseIcon="pi pi-upload" chooseLabel="Upload">
            </p-fileUpload>
            <div *ngIf="fileUploaded && fileUploaded.length > 0" class="efile-btn">
              <span class="fileuploaded-name mr-4">{{ fileUploaded[0].fileName }}</span>
              <button pButton pRipple type="button" title="view" (click)="onViewFile()" icon="pi pi-eye"
                class="p-button-rounded p-button-text"></button>
              <button pButton pRipple type="button" title="download" (click)="onDownloadFile()" icon="pi pi-download"
                class="p-button-rounded p-button-text"></button>
              <button pButton pRipple type="button" title="delete" (click)="onDeleteFile()" icon="pi pi-trash"
                class="p-button-rounded p-button-text"></button>
            </div>
            <small *ngIf="!fileUploaded || (fileUploaded && fileUploaded.length === 0)" class="p-error">Prevailing wage
              determination file is required.</small>
          </div>
        </div>
      </div>
      <p-divider></p-divider>
    </ng-template>
    <div class="row">
      <div class="col-12">
        <button type="submit"
          [disabled]="updateDeterminationForm.invalid || ((!fileUploaded || (fileUploaded && fileUploaded.length === 0)) && updateDeterminationForm.get('decisionCode').value === 'PWDISSUED')"
          class="p-btn btn btn-primary mr-3">SAVE</button>
        <button type="button" class="p-btn btn btn-light" (click)="onReset()">CANCEL</button>
      </div>
    </div>
  </form>
</div>